const aicBuilds = {
  state: {},
  mutations: {},
  getters: {
    getMeetingById: state => id => {
      return state.data[id] ? state.data[id] : null;
    },
  },
  actions: {},
};
export default aicBuilds;
